import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		image: {
			height: 'auto',
			width: '100%',
			maxHeight: '100%',
			display: 'block',
		},
		bgImage: ({ isBackground, metaData }) => {
			const styles =
				isBackground && metaData?.image
					? {
							backgroundImage: `url("${metaData.imageThumb}")`,
							...metaData.backgroundMediaFrom(theme),
					  }
					: {
							backgroundImage: null,
					  }

			return {
				backgroundSize: 'cover',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center',
				...styles,
			}
		},
	}),
	{ name: 'Image' },
)

export default useStyles
